export const environment = {
  production: true,
  encryptLocalStorage: true,
  useFirebaseEmulators: false,
  firebase: {
    projectId: 'lyxa-700fd',
    appId: '1:468739376893:web:68964bb6a430b8780ee094',
    storageBucket: 'lyxa-700fd.appspot.com',
    apiKey: 'AIzaSyAsAUXnT88odTRaJJFZCT1Yqzi1nrJDyCs',
    authDomain: 'lyxa-700fd.firebaseapp.com',
    messagingSenderId: '468739376893',
    measurementId: 'G-9Y03KE883V',
  },
  algolia: {
    applicationId: 'IVVT926CQ4',
    searchOnlyApiKey: '5bb74cb475d04362a3519e36627a7f93',
    indexName: 'public-decks-default-title-asc',
  },
  providers: [],
};
